<template>
    <div>
        <h1 style="font-size: 24px; color: black;">渠道管理</h1>
        <el-card class="form-container" shadow="never">
            <el-button class="sub-sub" type="primary" @click="showDetails('新增渠道')">新增</el-button>
        </el-card>
        <h1>
            <el-table :data="datas"
                      border
                      :fit="true">
                <el-table-column label="id" prop="id" width="50px" align="center"></el-table-column>
                <el-table-column label="渠道" prop="channel" width="200px" align="center"></el-table-column>
                <el-table-column label="备注" prop="remark" width="50px" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="showDetails('编辑',scope.row)">编辑</el-button>
                        <!-- <el-button type="danger" size="small" @click="remove(scope.row.id)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="coverForm">
                <el-form-item label="名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="coverForm.channel" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注：" :label-width="labelWidth">
                    <el-input type="text" v-model="coverForm.remark"></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        saveChannel,
        deleteChannel,
        searchChannel
    } from "@/http/aiBookAdminApi";
    export default {
        name: "AiBookChannelConfig",
        data(){
            return{
                headers:{},
                dialogVisible:false,
                dialogTitle:'',
                datas:[],
                labelWidth: '110px',
                coverForm: {
                    id: null,
                    remark: '',
                    channel:''
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                }
            }
        },
        methods:{
            showDetails(title,data){
                if (data){
                    this.coverForm= {
                        id: data.id,
                        channel: data.channel,
                        remark: data.remark
                    }
                }else {
                    this.coverForm= {
                        id: null,
                        channel: '',
                        remark:''
                    }
                }
                this.dialogTitle  = title;
                this.dialogVisible = true;
            },
            
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteChannel(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search();
                        }
                    });
                }).catch(() => {
                })
            },
            confirmForm(){
                let _message = '';
                if(this.coverForm.name===''){
                    _message = '请输入名称'
                }else if (this.coverForm.image===''){
                    _message = '请上传图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveChannel(this.coverForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            search(){
                searchChannel(this.page).then(resp=>{
                    this.datas = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
        }
    }
</script>

<style scoped>

</style>
